module.exports = __webpack_public_path__ + "img/drama.6d561a7d.png";